import _defineProperty from "@babel/runtime/helpers/defineProperty";
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
import { Grid, GridItem } from '@nike/nike-design-system-components';
import uuid from 'react-uuid';
import Tile from '../Tile/Tile';
import { createElement as _createElement } from "react";
import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
function generateTiles(props) {
  var xfPath = props.xfPath,
    placement = props.placement,
    mediaHost = props.mediaHost,
    linkHost = props.linkHost,
    _props$root = props.root,
    tile1 = _props$root.tile1,
    tile2 = _props$root.tile2,
    tile3 = _props$root.tile3;
  return [tile1, tile2, tile3].map(function (tile) {
    return /*#__PURE__*/_jsx(GridItem, {
      xs: 4,
      "data-testid": "tile-grid-item",
      style: {
        height: '100%'
      },
      children: /*#__PURE__*/_createElement(Tile, _objectSpread(_objectSpread({}, tile), {}, {
        key: "".concat(xfPath, "-").concat(tile.title),
        xfPath: xfPath,
        placement: placement,
        mediaHost: mediaHost,
        linkHost: linkHost
      }))
    }, uuid());
  });
}

// We have to wrap the Tiles in a Grid when in Author mode, as there is no wrapping Grid in the parent component
function generateAuthorGrid(props) {
  return /*#__PURE__*/_jsx(Grid, {
    rowGapXs: "18px",
    exteriorGapXs: "0px",
    "data-testid": "multicolumntile-conditional-grid",
    placeholder: undefined,
    onPointerEnterCapture: undefined,
    onPointerLeaveCapture: undefined,
    children: generateTiles(props)
  });
}
var Multicolumntile = function Multicolumntile(props) {
  return /*#__PURE__*/_jsxs(_Fragment, {
    children: [props.isAuthor ? generateAuthorGrid(props) : generateTiles(props), ";"]
  });
};
export default Multicolumntile;